import React, { useState } from 'react';
import Modal from '../Modal';
import OfflineQueue from './OfflineQueue';
import { useCustomer } from '../../Data/Customers';
import Loading from '../Loading';
import Title from '../Formatting/Customer/Title';
import Subtitle from '../Formatting/Customer/Subtitle';
import ButtonRow from '../Button/ButtonRow';
import Button from '../Button/Button';
import MarkAsDone from '../../Pages/Customer/MarkAsDone';
import { useDialogues } from '../Dialogues';
import { useOffline } from '.';

const Errors = ({isOpen, onClose}) => {
    const {failedJobs} = useOffline();

    return <Modal title="Offline Sync Errors" isOpen={isOpen} setIsOpen={onClose} dismissible>
        <div className="prose prose-sm surface-1 mb-4">
            <p>The following changes failed to sync. This is probably because the data changed while you were offline.</p>
        </div>

        <div className="flex flex-col gap-4 border rounded-lg p-2">
            {failedJobs.map(data => {
                // TODO - match the job to a component
                return <MarkJobDone key={data.id} data={data} />
            })}
        </div>
    </Modal>
}

const MarkJobDone = ({data}) => {
    const [markingDone, setMarkingDone] = useState(false);
    const {customer} = useCustomer(data.entity.customerId, true, true);
    const {removeQueuedTask} = useOffline();
    const {confirm} = useDialogues();

    if (!customer) {
        return <Loading />;
    }

    const job = customer?.jobs?.find(j => j.id === data.entity.id);

    if (!job) {
        return <Loading />;
    }

    return <div className="flex flex-col gap-2 text-sm">
        <p>
            <strong><Title customer={customer} /></strong><br />
            <Subtitle customer={customer} />
        </p>


        <ButtonRow>
            <Button theme="secondary"
                label="Cancel"
                onClick={() => confirm(
                    {
                        theme: 'warning',
                        title: 'Cancel sync',
                        message: 'Are you sure you don\'t want to mark this job as done?',
                    },
                    () => removeQueuedTask(OfflineQueue.TASK_MARK_JOB_DONE, {id: job.id, model: 'Customers/Job'})
                )}
            />
            <Button theme="primary"
                label="Mark as done"
                onClick={() => setMarkingDone(true)}
            />
        </ButtonRow>

        <MarkAsDone
            isOpen={markingDone}
            onClose={() => setMarkingDone(false)}
            customer={customer}
            job={markingDone ? job : null}
        />
    </div>;
}

export default Errors;
